import { FC } from 'react'
import { Text, Button, Icon } from '@/client/components'
import { IconName } from '@/client/components/Icon/types'
import { useRouterPush } from '@/client/hooks'
import * as S from './styles'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Social: FC<any> = ({ content }) => {
  const { routerPush } = useRouterPush()

  return (
    <>
      <S.SocialWrapper>
        <Text as='p' size='xlg' weight='bold' family='text' className='socialwrapper-header'>
          {content['follow_us_name']}
        </Text>
        <S.NavSocialLink>
          {content['social_media_links']?.map(({ url, platform }) => (
            <S.SocialLink
              key={platform['label']}
              type={platform['value']}
              href={url}
              target='_blank'
              rel='noopener noreferrer'
              aria-label={platform['label']}
            >
              <Icon name={platform['value'] as IconName} size='s4' color='black' />
            </S.SocialLink>
          ))}
        </S.NavSocialLink>
        <Text as='p' size='sm' className='socialmedia-help' family='text'>
          {content['newsletter_help']}
        </Text>
        <Button
          type='button'
          kind='action'
          className='subscribebutton'
          color='white'
          onClick={() => routerPush(content['subscription_url'])}
        >
          {content['subscribe_button']}
        </Button>
      </S.SocialWrapper>
    </>
  )
}
